import React from 'react';
import './LegalPage.css';

const Terms = () => {
  return (
    <div className="legal-page">
  <h2>1. Identificación del titular</h2>

  <p><strong>Titular:</strong> DMG BSNS SLU</p>
  <p><strong>NRT:</strong> L-719268-A</p>
  <p><strong>Domicilio:</strong> Avinguda Príncep Benlloch, 26-30, Edifici Clara Rabassa, Taula C39 AD500 Andorra la Vella</p>
  <p><strong>Correo electrónico:</strong> <a href="mailto:ceocloseracademy@gmail.com">ceocloseracademy@gmail.com</a></p>
  <p><strong>Sitio Web:</strong> <a href="https://landing.closeracademy.app" target="_blank" rel="noopener noreferrer">https://landing.closeracademy.app</a></p>

  <h2>2. Objeto del contrato</h2>

  <p>
    Estas condiciones regulan el acceso, navegación y contratación de los productos o servicios ofrecidos en esta web,
    consistentes principalmente en formación digital.
  </p>

  <p>El servicio contratado incluye, entre otros:</p>

  <ul>
    <li>Acceso a una plataforma con contenido formativo grabado.</li>
    <li>Clases en directo semanales con el equipo de formadores durante el periodo activo de la formación.</li>
    <li>Documentación complementaria descargable (guías, plantillas, material de apoyo).</li>
    <li>Acceso a comunidad privada de alumnos en Slack.</li>
    <li>Sesiones grupales de resolución de dudas.</li>
    <li>Participación en procesos de selección con empresas colaboradoras (según desempeño y evaluación del alumno).</li>
  </ul>

  <p>
    El contenido puede actualizarse sin suponer una reducción del valor del producto contratado.
  </p>

  <h2>3. Precio</h2>

  <p>El precio total del producto es de <strong>1.997 €</strong>.</p>

  <h2>4. Edad mínima y acceso</h2>

  <p>El Usuario declara tener al menos 18 años.</p>

  <p>El acceso a la formación es personal e intransferible.</p>

  <h2>5. Proceso de compra y medios de pago</h2>

  <p>
    El Usuario podrá adquirir los productos o servicios mediante transferencia bancaria a la cuenta indicada o a través
    de plataformas externas como:
  </p>

  <ul>
    <li><strong>Hotmart B.V.:</strong> distribución y gestión del contenido digital.</li>
    <li><strong>SeQura Worldwide S.A.:</strong> financiación y pago aplazado.</li>
  </ul>

  <p>Cada plataforma aplica sus propios términos y políticas.</p>

  <p>
    Antes de finalizar la compra, el Usuario deberá aceptar expresamente estos Términos y Condiciones marcando la casilla
    correspondiente. Sin esta aceptación expresa no será posible completar el proceso de compra.
  </p>

  <h3>5.1 Pago fraccionado directo con la Empresa</h3>

  <p>
    En el supuesto de que el Alumno/Cliente opte por la modalidad de pago aplazado gestionado directamente por la Empresa,
    el abono de las cuotas mensuales deberá realizarse en las fechas de vencimiento designadas. El impago de cualquiera de
    las cuotas facultará a la Empresa para suspender cautelarmente el acceso a la plataforma digital de formación.
  </p>

  <p>
    Transcurridos sesenta (60) días naturales desde el primer impago total o parcial de cualquier cantidad adeudada,
    y habiendo mediado requerimiento previo de pago por conducto fehaciente (correo electrónico certificado, burofax o
    sistema equivalente), la Empresa se reserva el derecho de declarar el vencimiento anticipado de la totalidad del crédito
    pendiente.
  </p>

  <p>
    En consecuencia, la Empresa podrá exigir de inmediato, en un único pago y por la vía judicial o extrajudicial, el 100%
    de las cantidades aplazadas que resten por abonar hasta la finalización del programa formativo, incrementadas con los
    intereses de demora y gastos de gestión de cobro lícitamente devengados.
  </p>

  <h3>5.2 Financiación vinculada a través de entidad financiera externa y Pacto de Recompra</h3>

  <p>
    En caso de que el aplazamiento se haya articulado mediante un contrato de financiación suscrito entre el Alumno/Cliente
    y una entidad financiera colaboradora de la Empresa, el régimen inicial de impagos se someterá a las condiciones pactadas
    con dicha entidad.
  </p>

  <p>
    No obstante lo anterior, si el impago frente a la entidad financiera se prolongase por un plazo igual o superior a
    sesenta (60) días naturales, y en virtud de los acuerdos de colaboración y pacto de recompra suscritos entre la Empresa
    y la financiera, esta última procediera a la resolución del crédito y a la devolución o cesión del derecho de cobro a
    favor de la Empresa, esta asumirá la condición de acreedor directo del Alumno/Cliente.
  </p>

  <p>
    Una vez notificada formalmente dicha cesión de crédito al deudor, la Empresa quedará plenamente facultada para aplicar
    el régimen de vencimiento anticipado regulado en el apartado anterior de esta cláusula, quedando expedita la vía para
    reclamar de forma inmediata el 100% de la totalidad de la deuda restante del programa formativo.
  </p>

  <h2>6. Derecho de desistimiento y política de devoluciones</h2>

  <p>
    De acuerdo con la normativa aplicable, el Usuario dispone de un plazo máximo de 14 días naturales desde la fecha de
    contratación para solicitar la devolución del importe abonado.
  </p>

  <p>
    Este derecho solo será aplicable siempre y cuando el Usuario no haya utilizado de ningún modo el contenido digital
    del producto.
  </p>

  <p>
    A efectos legales, se entenderá que el Usuario ha utilizado el contenido digital cuando haya realizado cualquiera
    de las siguientes acciones:
  </p>

  <ul>
    <li>Haya entrado en la plataforma de formación y haya interactuado con ella.</li>
    <li>Haya abierto o reproducido, total o parcialmente, alguno de los vídeos grabados.</li>
    <li>Haya asistido o se haya conectado a una clase en directo.</li>
    <li>Haya descargado, abierto o consultado material complementario (guías, PDFs, plantillas, etc.).</li>
    <li>Haya consultado cualquier recurso, documento o contenido incluido dentro de la formación.</li>
    <li>O haya realizado cualquier acción que implique consumo, visualización o uso del contenido digital.</li>
  </ul>

  <p>
    Una vez se haya producido cualquiera de estas acciones —equivalentes a la apertura de un paquete físico en el comercio
    tradicional—, el derecho de desistimiento quedará automáticamente anulado, y no se admitirán devoluciones, salvo que la
    oferta comercial indique expresamente lo contrario.
  </p>

  <p>El impago de cuotas no exime del cumplimiento íntegro del importe pactado.</p>

  <h2>7. Duración del acceso</h2>

  <p>
    El acceso al contenido digital y a la formación tendrá una duración total de 12 meses desde la fecha de inscripción.
  </p>

  <p>
    Finalizado este periodo, el acceso podrá desactivarse sin obligación de mantener disponibilidad posterior.
  </p>

  <p>No implica acceso vitalicio ni disponibilidad ilimitada en el tiempo.</p>

  <h2>8. Propiedad intelectual</h2>

  <p>
    Todos los contenidos del sitio web y del programa formativo están protegidos por derechos de autor.
  </p>

  <p>
    Queda prohibida su reproducción, distribución o modificación sin autorización expresa del titular.
  </p>

  <h2>9. Oportunidades laborales</h2>

  <p>
    Se facilitará el acceso a procesos de selección gestionados con empresas colaboradoras.
  </p>

  <p>
    La obtención de un puesto de trabajo dependerá exclusivamente del desempeño, compromiso y superación de las pruebas
    por parte del alumno.
  </p>

  <p>
    En ningún caso se garantiza una colocación directa o automática. La empresa no asume responsabilidad alguna si el alumno
    no accede a una oportunidad laboral tras finalizar la formación.
  </p>

  <h2>10. Limitación de responsabilidad</h2>

  <p>
    Todos los materiales ofrecidos, tanto contenido teórico grabado como las clases en directo, se proporcionan
    “tal cual” y “según disponibilidad”.
  </p>

  <p>Esto significa que:</p>

  <ul>
    <li>
      El acceso al contenido teórico grabado puede actualizarse, modificarse o reorganizarse en función de mejoras formativas
      o necesidades operativas.
    </li>
    <li>
      Las clases en directo pueden variar en horarios, formato, duración o disponibilidad por motivos organizativos, técnicos
      o de agenda, sin que ello implique incumplimiento por parte del titular.
    </li>
    <li>
      El progreso y los resultados del alumno dependen exclusivamente de su compromiso, participación, ejecución y
      circunstancias personales, por lo que no se garantiza la obtención de resultados específicos.
    </li>
  </ul>

  <p>
    DMG BSNS SLU no será responsable de daños directos o indirectos, pérdidas económicas, falta de resultados, interrupciones
    del servicio o cualquier consecuencia derivada del uso o no uso de la formación.
  </p>

  <h2>11. Legislación aplicable y jurisdicción</h2>

  <p>
    Este contrato se rige por la legislación del Principado de Andorra.
  </p>

  <p>
    Ambas partes se someten a los tribunales andorranos para la resolución de cualquier conflicto.
  </p>

  <h2>12. Aceptación de condiciones</h2>

  <p>
    Antes de completar el proceso de compra, el Usuario debe aceptar de forma expresa, consciente e informada estos
    Términos y Condiciones, así como la Política de Privacidad, el Aviso Legal y la Política de Cookies, mediante la
    marcación de la casilla correspondiente habilitada al efecto.
  </p>

  <p>
    La contratación solo podrá completarse si el Usuario confirma haber leído, comprendido y aceptado dichas condiciones,
    reconociendo que constituyen el acuerdo legal que regula la relación entre ambas partes.
  </p>

  <p>© 2026 Closer Academy. Todos los derechos reservados.</p>
  </div>


  );
};

export default Terms;
